import { useLocation } from 'react-router-dom'
import { useAuth } from '@/features/auth/AuthProvider'
import { formatDateTime } from '@/lib/utils'
import { useState, useEffect } from 'react'

const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/ventas': 'Nueva venta',
  '/ventas/historial': 'Historial de ventas',
  '/caja': 'Caja',
  '/productos': 'Productos',
  '/stock': 'Stock',
  '/compras': 'Compras',
  '/retiros': 'Retiros',
  '/clientes': 'Clientes',
  '/clientes/deudas': 'Cuenta corriente',
  '/reportes': 'Reportes',
  '/categorias': 'Categorias',
  '/depositos': 'Depositos',
  '/configuracion': 'Configuracion',
  '/usuarios': 'Usuarios',
}

export default function TopBar() {
  const { pathname } = useLocation()
  const { profile } = useAuth()
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(t)
  }, [])

  const title = PAGE_TITLES[pathname] ?? 'MayoExpress'

  return (
    <div className="me-topbar">
      <h1 style={{
        flex: 1,
        margin: 0,
        fontFamily: 'var(--me-display)',
        fontVariationSettings: '"opsz" 24, "wght" 600',
        fontSize: 18,
        letterSpacing: '-0.02em',
      }}>
        {title}
      </h1>

      {/* Date/time */}
      <div style={{
        fontSize: 12.5,
        color: 'var(--me-text-3)',
        fontFamily: 'var(--me-mono)',
        letterSpacing: '-0.01em',
        whiteSpace: 'nowrap',
      }}>
        {formatDateTime(now)}
      </div>

      {/* Separator */}
      <div style={{ width: 1, height: 20, background: 'var(--me-line-2)', marginLeft: 4 }} />

      {/* User badge */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '5px 10px',
        borderRadius: 10,
        background: 'var(--me-surface-2)',
        border: '1px solid var(--me-line)',
      }}>
        <div style={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          background: 'var(--me-ok)',
          flexShrink: 0,
        }} />
        <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--me-text-2)' }}>
          {profile?.nombre ?? 'Usuario'}
        </span>
        <span style={{
          fontSize: 10.5,
          color: 'var(--me-text-4)',
          textTransform: 'capitalize',
          borderLeft: '1px solid var(--me-line-2)',
          paddingLeft: 7,
        }}>
          {profile?.roles?.nombre ?? ''}
        </span>
      </div>
    </div>
  )
}
